import { createClient } from '@supabase/supabase-js';

let supabaseClient;

function getAuthStorage() {
  const api = typeof window !== 'undefined' && window.electronAPI?.authStorage;
  if (!api) return undefined;
  return {
    getItem: (key) => api.getItem(key),
    setItem: (key, value) => api.setItem(key, value),
    removeItem: (key) => api.removeItem(key),
  };
}

export const getSupabaseClient = () => {
  if (supabaseClient) return supabaseClient;
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  if (!supabaseUrl || !supabaseKey) {
    throw new Error('Missing Supabase env vars');
  }

  const authOptions = {
    persistSession: true,
    autoRefreshToken: true,
  };
  const storage = getAuthStorage();
  if (storage) {
    authOptions.storage = storage;
  }

  supabaseClient = createClient(supabaseUrl, supabaseKey, { auth: authOptions });

  return supabaseClient;
};

export const supabase = getSupabaseClient();
